import { container } from '@framework/container';
import { symbols } from '@framework/container/symbols';
import { WindowEventManager } from '@view-model/application/shortcuts';

// ViewModel
container.bind<WindowEventManager>(symbols.WindowEventManager).to(WindowEventManager).inSingletonScope();
